import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { TextInput } from 'carbon-components-react'
import IconCheckMark from '../../../globals/images/icon-checkmark.svg'
import { MFADomain } from '../../domain/mfa.services'
import NormalizeInput from '../../shared/phoneNumberSection/PhoneNumberUtility'
import Container from '../../shared/container/Container'
import { MFA } from '../MFASteps'
import { trackEventMessage } from '../../../TelemetryService'
import { EventModel } from '../../../models/EventModel'
import { MFA_VERIFY, MFA_SMS_VERIFY, MFA_EMAIL_VERIFY, MFA_REMEMBER_ME } from '../../../constants'
import { LoadingButton as Button } from '../LoadingButton/LoadingButton' 
import MfaRememberMe from '../../shared/mfaRememberMe/MfaRememberMe'
import { mfaRememberMeLocalStorageValueExists } from '../../../utils/localStorageUtils'

export const MFAActivateFactor = ( { onGoBack, factorInfo, onVerifyCode, onClose, debounce, resendCode, time, factor, webId, fromEditProfileAfterEdition } ) => {
    
    const [ passCode, setPassCode ] = useState( '' )
    const [ showSentText, setShowSentText ] = useState( false )
    const [ showResendCode, setShowResendCode ] = useState( false )
    const [ isNotValidCode, setIsNotValidCode ] = useState( false )
    const [ currentlyOnFocus, setCurrentlyOnFocus ] = useState( true )    
    const [ codeAttempts, setCodeAttempts ] = useState( 0 )
    const [ mfaRememberMe, setMfaRememberMe ] = useState( false )
    const [ mfaRememberMeAlreadyActive, setMfaRememberMeAlreadyActive ] = useState( false )

    const factorInfoFormatted = factor == MFA.FACTORS.EMAIL ? factorInfo :  NormalizeInput( factorInfo )
    const title = factor == MFA.FACTORS.EMAIL ? MFA.ActivateFactor.emailTitle : MFA.ActivateFactor.smsTitle
    const description = factor == MFA.FACTORS.EMAIL ? MFA.ActivateFactor.emailDescription : MFA.ActivateFactor.smsDescription
    const verifyDtId = factor == MFA.FACTORS.EMAIL ? 'dt-mfa-setupemailcodeverification-verify' : 'dt-mfa-setupsmscodeverification-verify'
    const goBackDtId = factor == MFA.FACTORS.EMAIL ? 'dt-mfa-setupemailcodeverification-go-back' : 'ddt-mfa-setupsmscodeverification-go-back'
    const closeDtId = factor == MFA.FACTORS.EMAIL ? 'dt-mfa-setupemailcodeverification-close' : 'dt-mfa-setupsmscodeverification-close'
    const resendCodeDtId = factor == MFA.FACTORS.EMAIL ? 'dt-mfa-setupemailcodeverification-resend' : 'dt-mfa-setupsmscodeverification-resend'
    const enterCodeAriaDescription = factor == MFA.FACTORS.EMAIL ? MFA.ActivateFactor.enterCodeEmailAriaDescription : MFA.ActivateFactor.enterCodeSmsAriaDescription

useEffect( async () => {

    if( mfaRememberMeLocalStorageValueExists() ) setMfaRememberMeAlreadyActive( true ) 

    if( fromEditProfileAfterEdition ){
        await resendCode( true, MFA.FACTORS.EMAIL )
    }

    MFADomain.TimeOut( time ).then( () => setShowResendCode( true ) )
    
  return () => {
    setShowResendCode( false )
    setShowSentText( false )
  }
}, [] )

const handleClose = ( ) => {
    trackEventMessage( new EventModel( MFA_VERIFY.CLOSE, webId ) )
    onClose()
}

const handleGoBack = ( ) => {
    trackEventMessage( new EventModel( MFA_VERIFY.GO_BACK, webId ) )
    onGoBack()
}

const handleChangeCode = e => {
    const value = e.target.value
    const currentValue = value.replace( /[^\d]/g, '' )
    if( currentValue.length >= 0  && currentValue.length <= 6 )
    setPassCode( currentValue  )
    setIsNotValidCode( false )
}

const isFormatValid = ( ) => {
    return passCode.length > 0 && passCode.length >= 6
}

const verifyCode = async ( event ) => { 
    event.preventDefault()
    const aiMessage = factor == MFA.FACTORS.EMAIL ? MFA_EMAIL_VERIFY.VERIFY_CODE : MFA_SMS_VERIFY.VERIFY_CODE
    trackEventMessage( new EventModel( aiMessage, webId ) )
    if( mfaRememberMe )  trackEventMessage( new EventModel( MFA_REMEMBER_ME.CHECKED, webId ) ) 
    if ( isFormatValid() && codeAttempts<5 ) {
        const verifyResponse = await onVerifyCode( passCode, mfaRememberMe  )   
        setIsNotValidCode( !verifyResponse )
        setCodeAttempts( codeAttempts+1 )  
    }     
 }

 const onHandleResendCode = async () => { 
    const aiMessage = factor == MFA.FACTORS.EMAIL ? MFA_EMAIL_VERIFY.RESEND_EMAIL : MFA_SMS_VERIFY.RESEND_SMS
    trackEventMessage( new EventModel( aiMessage, webId ) )
    const resendSuccess = await resendCode( true, factor )
    if( resendSuccess ) {
        setShowSentText( resendSuccess )
        MFADomain.TimeOut( time ).then( () => { 
            setShowSentText( false )
            setShowResendCode( true ) 
        } )
    }    
  }

  return ( <Container onClose={ handleClose } onCloseButtonId={ closeDtId }>  
      <form >
          <div><header tabIndex='0' className='mb-4 c-mfa-label--title' aria-label={  title }>{ title }</header>
          </div>
          <p className='c-mfa-label--content' aria-label={ description } tabIndex='0'> { description } </p>
          <div className='mb-5'><p className='c-mfa-label--content c-mfa-card__phone-number wrap-text' aria-label={ factorInfoFormatted } tabIndex='0'> { factorInfoFormatted } </p></div>
          <div className='mb-5 not-receive-the-text-content'>
              {showResendCode && <div className='mr-4'><label className='not-receive-the-text mr-4' tabIndex='0'>{ MFA.ActivateFactor.didNotReceiveText } </label></div>}
              { !showSentText ? showResendCode && <Button debounce={ debounce } id={ resendCodeDtId } className='mfa-resend-code mfa-app-link  u-btn-clear' onClick={ onHandleResendCode } data-testid = 'resendCodeID' tabIndex='0'>{ MFA.ActivateFactor.ResendCode }</Button>: 
              <div>
                  <img tabIndex='0' src={ IconCheckMark } alt="Sent" className='c-mfa-svg-sent' data-testid = 'sent-icon'/>
                  <label className='mfa-code-sent' tabIndex='0'>{ MFA.ActivateFactor.sent }</label>
              </div>}
          </div>
          <div className="mb-3">
              <TextInput labelText={ MFA.ActivateFactor.enterCode } className="c-form-input" id="enterCodeId" type="text" required autoComplete='off' tabIndex={ 0 }
                                        value={ passCode } onChange={ handleChangeCode }
                                        onBlur={ () => setCurrentlyOnFocus( false ) }
                                        onFocus= { () => setCurrentlyOnFocus( true ) }
                                        autoFocus 
                                        aria-label={ enterCodeAriaDescription }
                                        invalidText= { codeAttempts>=5?'The maximum number of attempts has been reached. Please try again later': ( isNotValidCode ? MFA.ActivateFactor.incorrectCodeMessage : '' ) }
                                        invalid={ !currentlyOnFocus && ( !isFormatValid() || isNotValidCode ) } 
                                        inputMode= 'numeric'
                                        data-testid= 'enterCodeId'
                                        />
          </div> 
          { 
              ( mfaRememberMe || !mfaRememberMeAlreadyActive ) && <div className="mb-6">
                  <MfaRememberMe rememberMeCheck={ ( checked ) => setMfaRememberMe( checked ) } ></MfaRememberMe>
              </div> 
          }                 
          {codeAttempts<5?<div className='mb-7'>
              <Button debounce={ debounce } id={ verifyDtId } className={ ` ${ isFormatValid() ? 'c-btn c-btn--primary' : 'c-btn c-btn--disabled' } mb-5` } type="button" onClick={ verifyCode } aria-label= { `verify ${ isFormatValid() ? 'enable' : 'disabled' } ` } name="verify" data-testid="btn-verifyCode">{ MFA.ActivateFactor.verify }</Button>
              <Button id={ goBackDtId } className={ 'c-btn c-btn--tertiary mb-5' } onClick={ ( ) => handleGoBack() } aria-label='Go Back enable' name="goBack" type='button' data-testid="btn-verifyGoBack">{ MFA.goBack }</Button>
          </div>:
          <Button id='close-btb' className={ 'c-btn c-btn--tertiary mb-5' } onClick={ ( ) => handleClose() } aria-label='Close enabled' name="goBack" type='button' data-testid="btn-close">{ MFA.close }</Button>
          
          }
      </form>
  </Container>
   )
}

MFAActivateFactor.propTypes = {
  onGoBack: PropTypes.func,
  onVerifyCode: PropTypes.func,
  onClose: PropTypes.func,
  factorInfo: PropTypes.string,
  resendCode:  PropTypes.func,
  time: PropTypes.number,
  factor: PropTypes.number,
  webId: PropTypes.string,
  fromEditProfileAfterEdition: PropTypes.bool,
  debounce: PropTypes.bool
}